import actions from '@/modules/inspections/store/actions'
import getters from '@/modules/inspections/store/getters'
import mutations from '@/modules/inspections/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
